(function () {
  var STORAGE_KEY = "gclid_record";
  var CART_ATTR_KEY = "gclid";
  var COOKIE_DAYS = 90;

  function getParam(name) {
    var url = new URL(window.location.href);
    return url.searchParams.get(name);
  }

  function nowMs() {
    return new Date().getTime();
  }

  function getExpiryRecord(value) {
    var expiryDate = nowMs() + COOKIE_DAYS * 24 * 60 * 60 * 1000;
    return {
      value: value,
      expiryDate: expiryDate
    };
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function saveGclidFromUrl() {
    var gclid = getParam("gclid");
    var gclsrc = getParam("gclsrc");

    var isGclsrcValid = !gclsrc || gclsrc.indexOf("aw") !== -1;
    if (!gclid || !isGclsrcValid) return null;

    var record = getExpiryRecord(gclid);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (e) {
      // localStorage kann blockiert sein
    }

    setCookie("gclid", gclid, COOKIE_DAYS);
    return record;
  }

  function getStoredGclid() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.value && parsed.expiryDate && nowMs() < parsed.expiryDate) {
          return parsed.value;
        }
      }
    } catch (e) {
      // ignore
    }

    var cookieValue = getCookie("gclid");
    return cookieValue || null;
  }

  function getCart() {
    return fetch(window.Shopify.routes.root + "cart.js", {
      credentials: "same-origin"
    }).then(function (res) {
      return res.json();
    });
  }

  function updateCartAttribute(gclid) {
    return fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        attributes: {
          gclid: gclid
        }
      })
    }).then(function (res) {
      return res.json();
    });
  }

  function cartAlreadyHasGclid(cart, gclid) {
    return cart && cart.attributes && cart.attributes.gclid === gclid;
  }

  async function syncGclidToCart() {
    var gclid = getStoredGclid();
    if (!gclid) return;

    try {
      var cart = await getCart();

      if (cartAlreadyHasGclid(cart, gclid)) {
        return;
      }

      await updateCartAttribute(gclid);
      console.log("[gclid] cart attribute updated");
    } catch (err) {
      console.error("[gclid] failed to sync cart attribute", err);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    saveGclidFromUrl();
    syncGclidToCart();
  });
})();